import { useEffect, useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth, usernameToEmail } from "firebaseClient";

function DBLogin(props) {
  const setAuthenticated = props.setAuthenticated;
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [incorrect, setIncorrect] = useState(false);

  useEffect(() => {
    if (incorrect) {
      setTimeout(() => setIncorrect(false), 5000);
    }
  }, [incorrect]);

  const handleChange = (event) => {
    if (event.keyCode === 13) {
      if (event.target.id === "username") {
        document.getElementById("password").focus();
      } else {
        console.log("on submit?");
        onSubmit();
      }
    }
    setIncorrect(false);
    if (event.target.id === "username") {
      setUsername(event.target.value);
    }
    if (event.target.id === "password") {
      setPassword(event.target.value);
    }
  };

  async function onSubmit() {
    setIncorrect(false);
    try {
      const response = await signInWithEmailAndPassword(
        auth,
        usernameToEmail(username),
        password,
      );
      if (response) setAuthenticated(true);
    } catch (error) {
      setPassword("");
      setIncorrect(true);
    }
  }

  return (
    <div className="login-input-wrapper">
      <div className="login-input">
        <div
          className={`new-res-header ${
            incorrect ? "reserve-select-error" : ""
          }`}
        >
          {" "}
          {incorrect ? "Incorrect Login" : "Dashboard Login"}{" "}
        </div>
        <input
          style={{ marginBottom: "15px" }}
          className={` new-res-input ${
            incorrect ? "reserve-select-error" : ""
          }`}
          id="username"
          type="username"
          placeholder="Username"
          onKeyUpCapture={(event) => handleChange(event)}
        ></input>
        <input
          className={` new-res-input ${
            incorrect ? "reserve-select-error" : ""
          } `}
          id="password"
          placeholder="Password"
          onKeyUpCapture={(event) => handleChange(event)}
          type="password"
        ></input>
        <button
          className="submit-button submit-new-res"
          type="button"
          onClick={() => {
            onSubmit();
          }}
        >
          Login
        </button>
      </div>
    </div>
  );
}

export default DBLogin;
